import Images from "./components/Images";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Images />
    </div>
  );
}

export default App;
